// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"480":"0533ee63bed50241","622":"97f1d6012ec59d1a","696":"f89f8c3528189642"}[chunkId] + ".js";
};